<template>
  <div class="row">
    <div class="col titre">
      <h2>Ajouter Message utilisateur</h2>
    </div>
  </div>
  <AjouterFormMessage @sauvegarder="sauvegarder"/>
</template>

<script>
import AjouterFormMessage from '../../../components/pilotage/MessageUtilisateur/AjouterFormMessage.vue'
export default {
  components: {
    AjouterFormMessage
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter Message Utilisateur");
  },
  methods: {
    sauvegarder(message){
      this.$store.dispatch('pilotage/ajouterMessageAction', {message: message}).then(() => {
        this.$root.$refs.breadcrumbComp.rediriger();
      });
    }
  }
}
</script>
